import { AuthService } from "../auth/auth.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { GetService } from "./get.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../environments/environment";
import { AppStorageType } from "app/models/AppStorageType";

@Injectable()
export class AppMemoryService {
  public static: Static;
  public staticLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public pdfSrc: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public user: User;
  public isShowTooltip = true;
  public isShowTutorial = true;
  private horsesListViewTypeMethod: string;

  public pageInfo = {
    title: "",
    isHorse: false as boolean,
  };

  public horse: any;

  public year: number;

  public farms: Farms[];
  public countries = new BehaviorSubject(null);
  public regions = new BehaviorSubject(null);

  public gendersList: any;

  public pushInfo = {
    pushOld: [],
    pushNew: [],
  };

  public roles = {
    1: "/instructor",
    2: "/assistant",
    3: "/vet",
  };

  public userSubject = new BehaviorSubject(null);

  public measures = [
    {
      id: "mg",
      text: "mg",
    },
    {
      id: "g",
      text: "g",
    },
    {
      id: "mcg",
      text: "mcg",
    },
    {
      id: "ml",
      text: "ml",
    },
    {
      id: "cc",
      text: "cc",
    },
    {
      id: "tube",
      text: "tube",
    },
    {
      id: "tub",
      text: "tub",
    },
    {
      id: "syringe",
      text: "syringe",
    },
    {
      id: "tablet",
      text: "tablet",
    },
    {
      id: "sachet",
      text: "sachet",
    },
    {
      id: "other",
      text: "other",
    },
  ];

  public weights = [
    {
      id: 1,
      text: "kg",
    },
    {
      id: 2,
      text: "lbs",
    },
  ];

  // public translation = [];
  public translates = {
    instructor: "trainer",
    assistant: "assistant",
    vet: "vet",
    approved: "approved",
    pending: "pending",
    cancelled: "cancelled",
    canceled: "cancelled",
    open: "Open",
    closed: "Closed",
    "intra-venous": "intraVenos",
    "intra-muscular": "intraMuscular",
    "intra-articular": "intraArticular",
    oral: "oral",
    other: "other",
  };

  addNewPush(push: any) {
    this.pushInfo.pushNew.unshift(push);
  }

  resetPush() {
    this.pushInfo.pushOld = this.pushInfo.pushOld.concat(this.pushInfo.pushNew);
    this.pushInfo.pushNew = [];
  }

  constructor(
    public getService: GetService,
    public router: Router,
    public authService: AuthService,
    private translationService: TranslateService // private app: AppComponent
  ) {
    this.isShowTooltip = localStorage.getItem("isShowTooltip") === "true";
    this.isShowTutorial = localStorage.getItem("showTutorial") === "true";
    this.getStatic();
    // this.getFarms();

    this.authService.changeLoginSubject.subscribe((islogged: any) => {
      this.getUser();

      if (!islogged) {
        this.clearPushData();
      }
    });
  }

  changeLanguageOnStaticRetrieve() {
    this.translationService.onLangChange.subscribe((e) => {
      this.setTranslation();
    });
  }

  setTranslation() {
    const translated: { id: string; text: string }[] = [] as {
      id: string;
      text: string;
    }[];
    this.measures.forEach((el) => {
      this.translationService
        .get(`OTHER.${el.id}`)
        .subscribe((word: string) => {
          translated.push({ id: el.id, text: word });
        });
    });
    this.measures = translated;

    this.translationService.get("OTHER.otherDrug").subscribe((word: string) => {
      if (this.static.drugs[0] && this.static.drugs[0].id === 0) {
        this.static.drugs.splice(0, 1);
        this.static.drugs.unshift({
          created_at: null,
          id: 0,
          name: word,
          updated_at: null,
        });
      } else {
        this.static.drugs.unshift({
          created_at: null,
          id: 0,
          name: word,
          updated_at: null,
        });
      }
    });
  }

  getStatic() {
    this.getService.getStatic().then(
      (res: any) => {
        this.static = res;
        this.static.appStorageType =
          res.appStorageType || AppStorageType.fileSystem;
        this.translationService
          .get("OTHER.otherDrug")
          .subscribe((word: string) => {
            this.static.drugs.unshift({
              created_at: null,
              id: 0,
              name: word,
              updated_at: null,
            });
          });
        this.makeGendersList();
        this.makeCountries();
        this.makeRegions();
        this.changeLanguageOnStaticRetrieve();
        // this.setTranslation();
        this.staticLoaded.next(true);
        this.pdfSrc.next("");
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  makeGendersList() {
    const genders = this.static.genders;

    this.gendersList = genders.reduce(function (obj, item) {
      obj[item.id] = {
        id: item.id,
        name: item.name,
        color: item.color,
      };
      return obj;
    }, {});
  }

  makeCountries() {
    this.countries.next(this.static.countries);
  }

  makeRegions() {
    this.regions.next(this.static.regions);
  }

  getUser() {
    if (this.authService.isLoggedIn) {
      this.getService.getUser().then(
        (res: any) => {
          this.setUser(res);
          this.userSubject.next(true);
        },
        (err: any) => {
          this.setUser(null);
          this.userSubject.next(false);
        }
      );
    } else {
      this.user = null;
      this.userSubject.next(false);
    }
  }

  setUser(user: any) {
    this.user = user;
  }

  clearPushData(): void {
    this.pushInfo.pushNew.length = 0;
    this.pushInfo.pushOld.length = 0;
  }

  setTooltip(isShowTooltip: boolean) {
    this.isShowTooltip = isShowTooltip;
    localStorage.setItem("isShowTooltip", isShowTooltip + "");
  }

  setTutorial(isShowTooltip: boolean) {
    this.isShowTooltip = isShowTooltip;
    // this.app.showTutorialService();
    localStorage.setItem("isShowTooltip", isShowTooltip + "");
  }

  getTooltip(): boolean {
    return this.isShowTooltip;
  }

  getTutorial(): boolean {
    return this.isShowTutorial;
  }

  horsesListViewType(value?: any): string | void {
    if (value) {
      this.horsesListViewTypeMethod = value;
    }

    return this.horsesListViewTypeMethod;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/app-memory.service.ts